import domReady from '../helpers/dom-ready';

class LeftMenu {
  static init() {
    return new LeftMenu();
  }

  constructor() {
    this.menuButton = document.querySelector('.side-menu-button');
    this.menuWrapper = document.querySelector('.left-side-menu');

    if (this.menuButton) {
      this.addEventListeners(this.menuButton);
    }
  }

  addEventListeners(menuButton) {
    menuButton.addEventListener('click', () => {
      this.menuButton.classList.toggle('-open-menu');
      if (this.menuWrapper && !this.menuWrapper.classList.contains('-open')) {
        this.menuWrapper.classList.add('-open');
      } else {
        this.menuWrapper.classList.remove('-open');
      }
    });
  }
}
domReady(() => {
  LeftMenu.init();
});
